import React, { useEffect, useState } from "react";
import {
  Table,
  Row,
  Col,
  Select,
  Form,
  DatePicker,
  Space,
  Input,
  Button,
  Typography,
  Tag,
} from "antd";
import { FilePdfOutlined, SearchOutlined } from "@ant-design/icons";
import { dropdownService, reportService } from "../../../services";
import { handlePDFDownload, handlePrint, exportToExcel } from "../../../utils/printing";

const { Title } = Typography;

function CustomerOverdueInvoice() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [customerDues, setCustomerDues] = useState([]);
  const [allcustomerDues, setAllCustomerDues] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const [payload, setPayload] = useState(null);
  const [customers, setCustomers] = useState([]);

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
    },
    {
      title: "Date",
      dataIndex: "Date",
      key: "Date",
    },
    {
      title: "Invoice No",
      dataIndex: "Invoice No",
      key: "Invoice No",
    },
    {
      title: "Description",
      dataIndex: "Description",
      key: "Description",
      render: (text) => text || "N/A",
    },
    {
      title: "DR",
      dataIndex: "DR",
      key: "DR",
    },
    {
      title: "CR",
      dataIndex: "CR",
      key: "CR",
    },
    {
      title: "BAL",
      dataIndex: "BAL",
      key: "BAL",
    },
    {
      title: "Amount Paid",
      dataIndex: "Amount Paid",
      key: "Amount Paid",
    },
    {
      title: "OutStanding",
      dataIndex: "Out Standing",
      key: "Out Standing",
    },
    {
      title: "ETA",
      dataIndex: "ETA",
      key: "ETA",
      render: (text) => text || "N/A",
    },
    {
      title: "Days",
      dataIndex: "Days",
      key: "Days",
    },
    {
      title: "Overdue",
      dataIndex: "Overdue",
      key: "Overdue",
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      render: (text) => (
        <Tag
          style={{
            backgroundColor: text === "PAID" ? "#06D652" : "#F04949",
            color: "white",
          }}
        >
          {text}
        </Tag>
      ),
    },
  ];

  const onFinish = (values) => {
    const payload = Object.fromEntries(
      Object.entries({
        ...values,
        from_date: values.from_date?.format("YYYY-MM-DD"),
        to_date: values.to_date?.format("YYYY-MM-DD"),
      }).filter(([_, value]) => value != null)
    );
    setPayload(payload);
    initialize(pagination.current, pagination.pageSize, payload);
  };

  const initialize = async (
    page = 1,
    pageSize = pagination.pageSize,
    payload = null
  ) => {
    setLoading(true);
    const { success, data } = await reportService.CustomerDues(page, payload);
    setLoading(false);
    if (success) {
      setCustomerDues(data);
      setPagination((prev) => ({
        ...prev,
        total: data.pagination.total,
        current: page,
        pageSize,
      }));
      getAll();
    }
    setLoading(false);
  };

  const getCustomers = async () => {
    const response = await dropdownService.fetchCustomers();
    if (response.success) {
      setCustomers(response.data);
    }
  };

  const getAll = async () => {
    setLoading(true);
    const { success, data } = await reportService.CustomerDues(payload, true);
    setLoading(false);
    if (success) {
      setAllCustomerDues(data.data);
    }
    setLoading(false);
  }

  useEffect(() => {
    getCustomers();
  }, []);
  return (
    <>
      <Title level={5}>Customer Due/OverDue Invoices</Title>
      <Form
        requiredMark={false}
        layout="vertical"
        form={form}
        onFinish={onFinish}
      >
        <Row gutter={24} className="mt-8">
          <Col span={6}>
            <Form.Item label="From date" name="from_date">
              <DatePicker style={{ width: "100%" }} placeholder="Select Date" />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item label="To date" name="to_date">
              <DatePicker style={{ width: "100%" }} placeholder="Select Date" />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item label="Customers" name="user_id">
              <Select placeholder="">
                {customers.map((cust) => (
                  <Select.Option key={cust.id} value={cust.id}>
                    {cust.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={2}>
            <Form.Item label={<></>}>
              <Space size={12}>
                <Button type="primary" htmlType="submit">
                  <SearchOutlined style={{ fontSize: "15px" }} />
                </Button>
                <FilePdfOutlined style={{ fontSize: 26 }} />
              </Space>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Col span={24}>
        <Row
          gutter={0}
          style={{
            padding: "8px",
            marginTop: "2px",
            background: "#F2F2F7",
            borderRadius: "4px",
          }}
          className="flex justify-between"
        >
          <Col span={12}>
            <div className="flex">
              <Button onClick={() => handlePrint(allcustomerDues, columns, "Customer Due/OverDue Report")} type='primary' size='small' style={{ padding: '4px', margin: "0 5px 0 5px" }} >
                <span style={{ fontWeight: "bold", padding: "3px" }}>Print</span>
              </Button>

              {/* <Button type='text' size='small' style={{ padding: '4px' }}>
                <FaRegFile style={{ fontSize: "20px" }} />
              </Button> */}

              <Button onClick={() => exportToExcel(allcustomerDues, "customer_due_overdue.xlsx")} type='primary' size='small' style={{ padding: '4px', margin: "0 5px 0 5px" }}>
                <span style={{ fontWeight: "bold", padding: "3px" }}>Excel</span>
              </Button>

              <Button onClick={() => handlePDFDownload(allcustomerDues, columns, "Customer Due/OverDue Report", false)} type='primary' size='small' style={{ padding: '4px', margin: "0 5px 0 5px" }}>
                <span style={{ fontWeight: "bold", padding: "3px" }}>PDF</span>
              </Button>

              {/* <Button type='text' size='small' style={{ padding: '4px' }}>
                <RiFileCopyLine style={{ fontSize: "24px" }} />
              </Button> */}
            </div>
          </Col>
          <Col span={12} style={{ textAlign: "right" }}>
            <Input
              placeholder="Search"
              prefix={<SearchOutlined />}
              className="w-auto lg:w-2/5"
            />
          </Col>
        </Row>
        <div id="printable-table">
          <Table
            columns={columns}
            scroll={{ x: "max-content" }}
            pagination={{
              current: pagination.current,
              total: pagination.total,
              pageSize: pagination.pageSize,
              onChange: (page) => initialize(page, pagination.pageSize, payload),
              showSizeChanger: false,
            }}
            loading={loading}
            dataSource={customerDues.data}
            style={{ marginTop: "10px" }}
            summary={() => (
              <Table.Summary.Row className="font-bold bg-[#B83D3D] text-white">
                <Table.Summary.Cell colSpan={4}></Table.Summary.Cell>
                <Table.Summary.Cell>
                  Total: <br />$
                  {parseFloat(customerDues?.totalInvoice || 0).toFixed(2)}
                </Table.Summary.Cell>
                <Table.Summary.Cell colSpan={1}>
                  Paid: <br />$
                  {parseFloat(customerDues?.totalPaid || 0).toFixed(2)}
                </Table.Summary.Cell>
                <Table.Summary.Cell colSpan={5}>
                  BAL: <br />${parseFloat(customerDues?.totalBal || 0).toFixed(2)}
                </Table.Summary.Cell>
                <Table.Summary.Cell colSpan={1}>
                  Due: <br />${parseFloat(customerDues?.totalDue || 0).toFixed(2)}
                </Table.Summary.Cell>
                <Table.Summary.Cell colSpan={1}></Table.Summary.Cell>
              </Table.Summary.Row>
            )}
          />
        </div>
      </Col>
    </>
  );
}

export default CustomerOverdueInvoice;
